import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

interface Props {
  valor: string;
  /** Lado en px del render final. */
  tam?: number;
  /** Si se da, muestra debajo un enlace para descargar el QR como PNG con ese nombre de archivo. */
  nombreArchivo?: string;
}

export function QR({ valor, tam = 224, nombreArchivo }: Props) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    let vivo = true;
    QRCode.toDataURL(valor, {
      width: tam * 2,
      margin: 1,
      errorCorrectionLevel: 'M',
      color: { dark: '#101828', light: '#ffffff' },
    })
      .then((d) => vivo && setSrc(d))
      .catch(() => vivo && setSrc(null));
    return () => {
      vivo = false;
    };
  }, [valor, tam]);

  if (!src) {
    return (
      <div
        className="animate-pulse rounded-2xl border border-borde bg-navy/5"
        style={{ width: tam, height: tam }}
        aria-hidden="true"
      />
    );
  }

  return (
    <div className="flex flex-col items-center gap-2">
      <img
        className="rounded-2xl border border-borde bg-white p-3"
        src={src}
        width={tam}
        height={tam}
        alt="Código QR de tu invitación"
      />
      {nombreArchivo && (
        <a
          href={src}
          download={nombreArchivo}
          className="text-sm font-medium text-navy underline underline-offset-2 hover:no-underline"
        >
          Descargar QR
        </a>
      )}
    </div>
  );
}
